<div class="p-component p-inputtext"><p-checkbox v-model="model" :binary="true"></p-checkbox></div>